import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import useReveal from "@/hooks/useReveal";
import { HOME } from "@/constants/testIds";

export default function PhilosophySection() {
  const r = useReveal();
  return (
    <section className="relative py-32 md:py-40">
      <div className="max-w-[1480px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-6">
        <div ref={r} className="col-span-12 md:col-span-5 md:col-start-1">
          <div className="eyebrow mb-6">The Philosophy</div>
          <h2 className="font-serif text-5xl md:text-6xl leading-[1] tracking-tight font-light">
            Travel as a quiet <em className="italic text-indigo_deep">act of listening</em>.
          </h2>
        </div>
        <div className="col-span-12 md:col-span-5 md:col-start-8 md:mt-32">
          <p className="dropcap text-lg leading-[1.85] text-ink/85 font-light">
            Blending the timeless beauty of tradition with the sophistication
            of modern luxury, Indiora Journeys is devoted to preserving the
            rich cultural heritage of our destinations while delivering
            refined, immersive experiences. Each journey is thoughtfully
            composed to celebrate the spirit and artistry of South Asia.
          </p>
          <div className="mt-10 flex items-center gap-6">
            <Link
              to="/about"
              data-testid={HOME.philosophyCta}
              className="inline-flex items-center gap-2 text-[11px] tracking-widest2 uppercase font-semibold border-b border-ink pb-1 hover:text-terracotta hover:border-terracotta transition-colors"
            >
              Read Our Story
              <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
